import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import setUpInterceptor from './newServices';
import { showToast } from '@/utils/toastMessage/ToastMessage';
import { setUpSuperAdminInterceptor } from '@/api/config';

/**
 * Provides functions to fetch data from the server.
 */
// const apiService = setUpInterceptor();
export const apiServiceRTQ = setUpInterceptor();

export const API = setUpSuperAdminInterceptor();

export const ShowAllData = {
  /**
   * Fetches details from the given URL.
   *
   * @param {string} url - The URL to fetch data from.
   * @param {function} navigate - The navigate function passed from the component.
   * @returns {Promise<Object>} A promise that resolves to the fetched data.
   */
  showDetails: async (url, navigate) => {
    // Initialize the interceptor with navigate

    try {
      // Make the API request using the configured apiService
      const response = await apiServiceRTQ.get(url);
      return response; // Assuming response contains the data directly
    } catch (error) {
      // Handle errors if needed
      throw error;
    }
  },

  getDetailsWithoutToast: async (url, navigate) => {
    // Initialize the interceptor with navigate
    // const apiService = setUpInterceptor(navigate, true);

    try {
      // Make the API request using the configured apiService
      const response = await apiServiceRTQ.get(url);
      return response; // Assuming response contains the data directly
    } catch (error) {
      // Handle errors if needed
      throw error;
    }
  },
};

export const useGetApiList = (url, options = {}) => {
  return useQuery({
    queryKey: ['getApi', url, options.params],
    queryFn: () => apiServiceRTQ.get(url, { params: options.params }),
    enabled: options.enabled ?? true,
    retry: options.retry ?? 0,
  });
};

export const useGetApiListNoToast = (url, options = {}) => {
  return useQuery({
    queryKey: ['getApi', url, options.params],
    queryFn: () => apiServiceRTQ.get(url, { params: options.params }),
    enabled: options.enabled ?? true,
    retry: options.retry ?? 0,
  });
};

export const useMutateGetApi = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ url }) => apiServiceRTQ.get(url),
    onSuccess: (data, variables) => {
      queryClient.setQueryData(['getApi', variables.url], data);
    },
  });
};
